import { GET } from 'utils/requests.utils'

const BASE_URL = '/app/landing_pages'

export const fetchItem = (id) => GET(`${BASE_URL}/${id}`)

export default fetchItem
